import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { apiSlice } from "./apiSlice";
import setMenuSlice from "./setMenuSlice";
import categoryReducer from "./categorySlice";
import cartListReducer from "./cartSlice";
import localCartListReducer from "./locallCartSlice"; 
import restaurantReducer from "./restaurantSlice";
import customerReducer from "./customerSlice"; 
import notificationSlice from "./notificationSlice";
import ordersReducer from "./ordersSlice";
import initialDataSlice from "./initialDataSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "restaurant",
    "category",
    "cartList",
    "localCartList",
    "customer",
    "orders",
    "initialData",
  ],
};

const rootReducer = combineReducers({
  setMenu: setMenuSlice,
  category: categoryReducer,
  cartList: cartListReducer,

  localCartList: localCartListReducer,
  restaurant: restaurantReducer,
  customer: customerReducer,
  notification: notificationSlice,
  orders: ordersReducer,
  initialData: initialDataSlice,
  [apiSlice.reducerPath]: apiSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(apiSlice.middleware),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;


